module.exports = __webpack_public_path__ + "img/power-pro-elite.33e8dbe9.svg";